<template>
  <div class="container-fluid mt-4">
    <div class="bg-white rounded shadow p-4">
      <h3 class="text-start mb-4">Shift Assignment (Current Week)</h3>

      <!-- Nurse Search -->
  <!--    <div class="mb-4">-->
  <!--      <label for="nurse-search" class="form-label">Search Nurse</label>-->
  <!--      <input-->
  <!--          id="nurse-search"-->
  <!--          type="text"-->
  <!--          class="form-control"-->
  <!--          v-model="searchQuery"-->
  <!--          placeholder="Type to search nurse..."-->
  <!--          @input="fetchNurses"-->
  <!--      />-->
  <!--    </div>-->

    <table class="table table-bordered text-center align-middle">
      <thead class="table-light">
      <tr>
        <th>Nurse Name</th>
        <th v-for="(day, index) in currentWeek" :key="index">
          {{ day.label }}<br />
          <small>{{ $formatDate(day.date) }}</small>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="nurse in filteredNurses" :key="nurse.id">
        <td>{{ nurse.user ? nurse.user.name : 'Unknown Nurse' }}</td>
        <td v-for="(day, index) in currentWeek" :key="index">
          <div class="position-relative" style="min-height: 40px;">
            <button
                class="btn btn-sm position-absolute"
                style="bottom: 2px; right: 2px;"
                @click="openShiftModal(nurse, day.date)"
                title="Assign shift"
            >
              +
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    </div>
  </div>
    
    <!-- Shift Assignment Modal -->
    <div v-if="showModal" class="custom-modal">
      <div class="modal-backdrop" @click="closeModal"></div>
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Assign Shift</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="saveShiftAssignment">
              <!-- Combined info line (Nurse, Department, Date) -->
              <div class="mb-3">
                <div class="nurse-info-header p-2 border rounded mb-2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>{{ selectedNurse.name }}</strong>
                      <span v-if="selectedNurse.department" class="ms-2 badge bg-info">
                        {{ selectedNurse.department }}
                      </span>
                    </div>
                    <div>
                      <span class="badge bg-secondary">{{ formatDateDisplay(shiftAssignment.assignment_date) }}</span>
                    </div>
                  </div>
                </div>
                <input type="hidden" v-model="selectedNurse.id">
              </div>
                
                <!-- Department is auto-populated from nurse's assigned department -->
                <input type="hidden" v-model="shiftAssignment.department_id">
                
                <!-- Shifts Dropdown -->
                <div class="mb-3">
                  <label for="shift" class="form-label">Shift</label>
                  <select class="form-select" id="shift" v-model="shiftAssignment.shift_id" required>
                    <option value="">Select Shift</option>
                    <option v-for="shift in shifts" :key="shift.id" :value="shift.id">
                      {{ shift.name }} ({{ shift.start_time }} - {{ shift.end_time }})
                    </option>
                  </select>
                </div>
                
                <!-- Role -->
                <div class="mb-3">
                  <label for="role" class="form-label">Role</label>
                  <select class="form-select" id="role" v-model="shiftAssignment.role" required>
                    <option value="">Select Role</option>
                    <option v-for="role in nurseRoles" :key="role" :value="role">
                      {{ role.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()) }}
                    </option>
                  </select>
                </div>
                
                <!-- Is Swap Eligible -->
                <div class="mb-3 form-check">
                  <input type="checkbox" class="form-check-input" id="isSwapEligible" v-model="shiftAssignment.is_swap_eligible">
                  <label class="form-check-label" for="isSwapEligible">Eligible for Shift Swap</label>
                </div>
                
                <!-- Notes -->
                <div class="mb-3">
                  <label for="notes" class="form-label">Notes</label>
                  <textarea class="form-control" id="notes" rows="3" v-model="shiftAssignment.notes"></textarea>
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
                  <button type="submit" class="btn btn-primary ms-2">Save Assignment</button>
                </div>
              </form>
            </div>
          </div>
        </div>
          </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: "",
      nurses: [],
      currentWeek: [],
      departments: [],
      shifts: [],
      nurseRoles: ['regular', 'charge_nurse', 'team_lead'],
      showModal: false,
      selectedNurse: {
        id: null,
        name: '',
        department: null
      },
      shiftAssignment: {
        nurse_id: null,
        department_id: '',
        shift_id: '',
        role: '',
        is_swap_eligible: false,
        assignment_date: '',
        notes: ''
      }
    };
  },
  computed: {
    filteredNurses() {
      if (!this.searchQuery) return this.nurses;
      return this.nurses.filter((n) =>
          n.user && n.user.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  methods: {
    generateWeek() {
      const today = new Date();
      const dayOfWeek = today.getDay(); // 0 (Sun) to 6 (Sat)
      const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
      const labels = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

      this.currentWeek = labels.map((label, i) => {
        const d = new Date();
        d.setDate(today.getDate() + mondayOffset + i);
        return {
          label,
          date: d.toISOString().slice(0, 10),
        };
      });
    },
    async fetchNurses() {
      try {
        const res = await this.$api.get("/nurses");
        this.nurses = res.data;
      } catch (err) {
        console.error("Failed to fetch nurses:", err);
      }
    },

    async fetchShifts() {
      try {
        const res = await this.$api.get("/shifts");
        this.shifts = res.data.data;
      } catch (err) {
        console.error("Failed to fetch shifts:", err);
        this.$toast.error("Failed to load shifts");
      }
    },
    openShiftModal(nurse, date) {
      // Get department ID from nurse
      const departmentId = nurse.department ? nurse.department.id : null;
      
      // Reset assignment form
      this.shiftAssignment = {
        nurse_id: nurse.id,
        department_id: departmentId,
        shift_id: '',
        role: '',
        is_swap_eligible: false,
        assignment_date: date,
        notes: ''
      };
      
      // Set selected nurse with department info
      this.selectedNurse = {
        id: nurse.id,
        name: nurse.user ? nurse.user.name : 'Unknown Nurse',
        department: nurse.department ? nurse.department.name : 'No Department'
      };
      
      // Open modal
      this.showModal = true;
    },
    async saveShiftAssignment() {
      try {
        // Validate required fields
        
        const payload = {
          ...this.shiftAssignment,
          nurse_id: this.selectedNurse.id
        };
        
        const response = await this.$api.post('/shift-assignments', payload);
        
        if (response.data) {
          this.$toast.success("Shift assigned successfully");
          this.showModal = false;
          
          // Optionally refresh data
          // this.fetchAssignments(); // You would need to implement this method
        }
      } catch (error) {
        console.error("Error saving shift assignment:", error);
        this.$toast.error("Failed to save shift assignment");
      }
    },
    formatDateDisplay(dateString) {
      if (!dateString) return 'N/A';
      
      const date = new Date(dateString);
      const options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };
      return date.toLocaleDateString(undefined, options);
    },
    
    closeModal() {
      this.showModal = false;
    },
    
    assignShift(nurseId, date) {
      // Legacy method kept for compatibility
      const nurse = this.nurses.find(n => n.id === nurseId);
      if (nurse) {
        this.openShiftModal(nurse, date);
      }
    }
  },
  mounted() {
    this.generateWeek();
    this.fetchNurses();
    // this.fetchDepartments();
    this.fetchShifts();
    
    // Import Bootstrap's modal JS - we need to ensure it's available
    // if (typeof bootstrap !== 'undefined') {
    //   this.modalInstance = new bootstrap.Modal(document.getElementById('shiftAssignmentModal'));
    // } else {
    //   console.error("Bootstrap JS is not loaded. Modal may not work properly.");
    // }
  },
};
</script>

<style scoped>
table {
  min-width: 100%;
  margin-top: 1rem;
}

th:first-child, td:first-child {
  text-align: left;
}

.btn {
  min-width: auto;
}

/* Custom Modal Styles */
.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

.modal-dialog {
  width: 100%;
  max-width: 500px;
  margin: 1.75rem auto;
  z-index: 1051;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  border-radius: 0.3rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
}

.form-check {
  display: flex;
  align-items: center;
}

.form-check-input {
  margin-right: 0.5rem;
}

.btn-close {
  background: transparent;
  font-size: 1.5rem;
  font-weight: 700;
  border: 0;
  opacity: 0.5;
}

.btn-close:hover {
  opacity: 1;
}

.nurse-info-header {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}
</style>
